import {css} from '../theme/css'
import {theme} from '../theme/theme'
import {makeStyles} from '../theme/UNSTABLE_makeStyles'

const classes = {
  root: css`
    min-height: ${theme.spacing(3.5)}px;
    display: inline-flex;
    align-items: flex-start;
    justify-content: center;
    box-sizing: border-box;
    background-color: ${theme.go.schemes.colors.system.BgMinor};
    border-radius: ${theme.spacing(1.75)}px;
    padding: ${theme.spacing(0.75)}px;
  `,
  icon: css`
    font-size: 16px;
  `,
  label: css`
    padding: ${theme.spacing(0, 0.75)};
    align-self: center;
    max-width: 450px;
    overflow: hidden;
  `,
  textWrap: css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
  `,
}

export type ClassKey = keyof typeof classes

export const useClasses = makeStyles(classes)
